module.exports = __webpack_public_path__ + "img/shoppinglist.75c39391.png";